/**
 * Signature Page
 * https://github.com/szimek/signature_pad
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

window.SignaturePad = require ('signature_pad');

$(function(){

    "use strict";

    // Get the elements
    let canvas = document.querySelector("canvas#signature-pad");
    let clearButton = document.querySelector("[data-action=signature-clear]");
    // If canvas is found
    if (canvas) {

        let signaturePad = new SignaturePad.default(canvas, {
            penColor        : 'rgb(66, 133, 244)',
            onEnd           : function(something){
                // Enable the form
                $(canvas).closest('form').find('input[type=submit]').prop('disabled', signaturePad.isEmpty())
                // Save to PNG
                $(canvas).closest('form').find('input[name="signature[image]"]').val(signaturePad.toDataURL("image/png"))
            },
        });

        // Resize and clear
        function resizeCanvas() {
            // When zoomed out to less than 100%, for some very strange reason,
            // some browsers report devicePixelRatio as less than 1
            // and only part of the canvas is cleared then.
            var ratio =  Math.max(window.devicePixelRatio || 1, 1);

            // This part causes the canvas to be cleared
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);

            // This library does not listen for canvas changes, so after the canvas is automatically
            // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
            // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
            // that the state of this library is consistent with visual state of the canvas, you
            // have to clear it manually.
            signaturePad.clear();
        }

        // On mobile devices it might make more sense to listen to orientation change,
        // rather than window resize events.
        // window.onresize = resizeCanvas;

        /**
         * Add clear event to the button
         *
         * @param  {event)
         * @return {event}
         */
        clearButton.addEventListener("click", function (event) {
            signaturePad.clear();
            // Disable the form
            $(canvas).closest('form').find('input[type=submit]').prop('disabled', signaturePad.isEmpty())
        });
    }

});



// WEBPACK FOOTER //
// ./resources/js/services/jquery/signature_pad.js